import { Routes } from '@angular/router';
import { authGuard } from 'app/guards/auth/auth-guard';
import { roleGuard } from 'app/guards/role/role-guard';

// Define routes specific to the admin role
export const adminRoutes: Routes = [
    {
        path: 'dashboard',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/dashboard/dashboard').then(m => m.Dashboard),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Dashboard'
        }
    },
    {
        path: 'dashboard/all-notifications',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/dashboard/admin-notification/admin-notification').then(m => m.AdminNotification),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Dashboard/Notifications'
        }
    },
    {
        path: 'fixigo-provider',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/fixigo-provider/fixigo-provider').then(m => m.FixigoProvider),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Fixigo Providers'
        }
    },
    {
        path: 'fixigo-provider/provider-details/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/fixigo-provider/fixigo-provider-details/fixigo-provider-details').then(m => m.FixigoProviderDetails),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Fixigo Providers'
        }
    },
    {
        path: 'fixigo-provider/job-details/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/fixigo-provider/job-details-page/job-details-page').then(m => m.JobDetailsPage),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Fixigo Providers'
        }
    },
    {
        path: 'owner-management',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/owner-management/owner-management').then(m => m.OwnerManagement),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Landlord Management'
        }
    },
    {
        path: 'owner-management/properties/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/owner-management/owner-property-list/owner-property-list').then(m => m.OwnerPropertyList),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Landlord Management'
        }
    },
    {
        path: 'property-details/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/owner-management/owner-property-details/owner-property-details').then(m => m.OwnerPropertyDetails),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Property Details'
        }
    },
    {
        path: 'property/details/:propertyId',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/property/property-detail/property-detail').then(m => m.PropertyDetail),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Property Details'
        }
    },
    {
        path: 'tenant-management',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/tenant-management/tenant-management').then(m => m.TenantManagement),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Tenant Management'
        }
    },
    {
        path: 'tenant-management/properties/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/tenant-management/tenant-property-list/tenant-property-list').then(m => m.TenantPropertyList),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Tenant Management'
        }
    },
    {
        path: 'property-management',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/property-management/property-management').then(m => m.PropertyManagement),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Property Management'
        }
    },
    {
        path: 'property-management/detail/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/property-management/property-management-detail/property-management-detail').then(m => m.PropertyManagementDetail),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Property Management'
        }
    },
    {
        path: 'communication',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/communication/communication').then(m => m.Communication),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Communication'
        }
    },
    {
        path: 'payment-management',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/payment-management/payment-management').then(m => m.PaymentManagement),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Payment Management'
        }
    },
    {
        path: 'job-disputes',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/job-disputes/job-disputes').then(m => m.JobDisputes),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Job Disputes'
        }
    },
    {
        path: 'job-disputes/job-details/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/job-disputes/job-details-page/job-details-page').then(m => m.JobDetailsPage),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Job Disputes'
        }
    },
    {
        path: 'subscription',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/subscription/subscription').then(m => m.Subscription),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Subscription'
        }
    },
    {
        path: 'referal-rewards',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/referal-rewards/referal-rewards').then(m => m.ReferalRewards),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Referal & Rewards'
        }
    },
    {
        path: 'move-out-management',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/move-out-management/move-out-management').then(m => m.MoveOutManagement),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Move Out Management'
        }
    },
    {
        path: 'move-out-details/:id',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/admin/move-out-management/move-out-details/move-out-details').then(m => m.MoveOutDetails),
        data: {
            isHeader: 0,
            isFooter: 0,
            isSidebar: 1,
            isNavbar: 1,
            role: 'admin',
            heading: 'Move Out Management'
        }
    },
];